import i18next from 'i18next'

const width750 = 750
const height448 = 448
const width55 = 55
const height55 = 55
const size150 = 150

const welcomeEmailImageInputPropsMinSize = {
  width: width750,
  height: height448,
}

export const welcomeEmailImageInputProps = {
  title: i18next.t('Landing page image'),
  entityName: 'image',
  wrapperClassName: 'welcome-email-quote-image',
  minSize: welcomeEmailImageInputPropsMinSize,
  cropper: {
    outputWidth: welcomeEmailImageInputPropsMinSize.width,
    outputHeight: welcomeEmailImageInputPropsMinSize.height,
    renderWidth: welcomeEmailImageInputPropsMinSize.width * 0.5,
    renderHeight: welcomeEmailImageInputPropsMinSize.height * 0.5,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

const badgeImagePropsMinSize = {
  width: 90,
  height: 90,
}

export const badgeImageProps = {
  title: i18next.t('Badge'),
  entityName: i18next.t('Badge'),
  minSize: badgeImagePropsMinSize,
  cropper: {
    outputWidth: badgeImagePropsMinSize.width,
    outputHeight: badgeImagePropsMinSize.height,
    renderWidth: badgeImagePropsMinSize.width * 0.8,
    renderHeight: badgeImagePropsMinSize.height * 0.8,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

export const promoPageSettingsImageInputMinSize = {
  width: 488,
  height: 274,
}

export const promoPageSettingsImageInputProps = {
  title: 'Background image',
  entityName: 'Background image',
  minSize: promoPageSettingsImageInputMinSize,
  cropper: {
    outputWidth: promoPageSettingsImageInputMinSize.width,
    outputHeight: promoPageSettingsImageInputMinSize.height,
    renderWidth: promoPageSettingsImageInputMinSize.width * 0.9,
    renderHeight: promoPageSettingsImageInputMinSize.height * 0.9,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

const promoPageV2BackgroundImageInputPropsMinSize = {
  width: 600,
  height: 600,
}

export const promoPageV2BackgroundImageInputProps = {
  title: 'Background Image',
  entityName: 'Background Image',
  size: 'lg',
  minSize: promoPageV2BackgroundImageInputPropsMinSize,
  cropper: {
    outputWidth: promoPageV2BackgroundImageInputPropsMinSize.width,
    outputHeight: promoPageV2BackgroundImageInputPropsMinSize.height,
    renderWidth: promoPageV2BackgroundImageInputPropsMinSize.width - promoPageV2BackgroundImageInputPropsMinSize * 0.1,
    renderHeight:
      promoPageV2BackgroundImageInputPropsMinSize.height - promoPageV2BackgroundImageInputPropsMinSize * 0.1,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

const promoPageV2QuoteAuthorImageInputPropsMinSize = {
  width: 80,
  height: 80,
}

export const promoPageV2QuoteAuthorImageInputProps = {
  title: 'Quote Author Image',
  entityName: 'Quote Author Image',
  size: 'sm',
  minSize: promoPageV2QuoteAuthorImageInputPropsMinSize,
  cropper: {
    outputWidth: promoPageV2QuoteAuthorImageInputPropsMinSize.width,
    outputHeight: promoPageV2QuoteAuthorImageInputPropsMinSize.height,
    renderWidth:
      promoPageV2QuoteAuthorImageInputPropsMinSize.width - promoPageV2QuoteAuthorImageInputPropsMinSize * 0.1,
    renderHeight:
      promoPageV2QuoteAuthorImageInputPropsMinSize.height - promoPageV2QuoteAuthorImageInputPropsMinSize * 0.1,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

const promoPageV2AboutPlatformImageInputPropsMinSize = {
  width: 630,
  height: 490,
}

export const promoPageV2AboutPlatformImageInputProps = {
  title: 'Secondary Image',
  entityName: 'Secondary image',
  size: 'lg',
  minSize: promoPageV2AboutPlatformImageInputPropsMinSize,
  cropper: {
    outputWidth: promoPageV2AboutPlatformImageInputPropsMinSize.width,
    outputHeight: promoPageV2AboutPlatformImageInputPropsMinSize.height,
    renderWidth:
      promoPageV2AboutPlatformImageInputPropsMinSize.width - promoPageV2AboutPlatformImageInputPropsMinSize.width * 0.1,
    renderHeight:
      promoPageV2AboutPlatformImageInputPropsMinSize.height -
      promoPageV2AboutPlatformImageInputPropsMinSize.height * 0.1,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

const promoPageV2InfoBoxesImagesInputPropsMinSize = {
  width: 125,
  height: 125,
}

export const promoPageV2InfoBoxesImagesInputProps = {
  title: 'Info Box Image',
  entityName: 'Info Box Image',
  size: 'sm',
  minSize: promoPageV2InfoBoxesImagesInputPropsMinSize,
  cropper: {
    outputWidth: promoPageV2InfoBoxesImagesInputPropsMinSize.width,
    outputHeight: promoPageV2InfoBoxesImagesInputPropsMinSize.height,
    renderWidth: promoPageV2InfoBoxesImagesInputPropsMinSize.width - promoPageV2InfoBoxesImagesInputPropsMinSize * 0.1,
    renderHeight:
      promoPageV2InfoBoxesImagesInputPropsMinSize.height - promoPageV2InfoBoxesImagesInputPropsMinSize * 0.1,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

export const orgInactiveNotificationsImageMinSize = {
  width: 500,
  height: 500,
}
// TODO: Looks like we don't use it
export const orgInactiveNotificationsImageInputProps = {
  title: 'Image',
  entityName: 'image',
  minSize: orgInactiveNotificationsImageMinSize,
  wrapperClassName: 'org-inactive-notifications-email-quote-image',
  cropper: {
    outputWidth: 500,
    outputHeight: 500,
    renderWidth: 250,
    renderHeight: 250,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

export const protrackLevelImageMinSize = {
  width: width750,
  height: height448,
}

export const protrackLevelImageInputProps = {
  title: 'Image',
  entityName: 'image',
  minSize: protrackLevelImageMinSize,
  wrapperClassName: 'protrack-level-image',
  cropper: {
    outputWidth: protrackLevelImageMinSize.width,
    outputHeight: protrackLevelImageMinSize.height,
    renderWidth: protrackLevelImageMinSize.width * 0.5,
    renderHeight: protrackLevelImageMinSize.height * 0.5,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

export const activityImageMinSize = {
  width: width750,
  height: height448,
}

export const activityImageInputProps = {
  entityName: 'image',
  minSize: activityImageMinSize,
  wrapperClassName: 'activity-image',
  cropper: {
    outputWidth: activityImageMinSize.width,
    outputHeight: activityImageMinSize.height,
    renderWidth: activityImageMinSize.width * 0.5,
    renderHeight: activityImageMinSize.height * 0.5,
    scale: {
      min: 50,
      max: 200,
    },
  },
}

export const orgMainLogoImageInput = {
  width: width55,
  height: height55,
}

export const orgMainLogoImageInputProps = {
  title: 'Main Logo',
  entityName: 'logo',
  minSize: orgMainLogoImageInput,
  wrapperClassName: 'organization-form-logo',
  cropper: {
    outputWidth: orgMainLogoImageInput.width,
    outputHeight: orgMainLogoImageInput.height,
    renderWidth: orgMainLogoImageInput.width * 0.5,
    renderHeight: orgMainLogoImageInput.height * 0.5,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

export const orgEmailLogoImageInput = {
  width: size150,
  height: size150,
}

export const orgEmailLogoImageInputProps = {
  title: 'Logo for Emails',
  minSize: orgEmailLogoImageInput,
  entityName: 'logo',
  wrapperClassName: 'organization-form-logo',
  cropper: {
    outputWidth: orgEmailLogoImageInput.width,
    outputHeight: orgEmailLogoImageInput.height,
    renderWidth: orgEmailLogoImageInput.width,
    renderHeight: orgEmailLogoImageInput.height,
    scale: {
      min: 50,
      max: 200,
    },
  },
}

export const proTrackLevelWelcomeEmailInput = {
  width: width750,
  height: height448,
}

export const proTrackLevelWelcomeEmailInputProps = {
  entityName: 'image',
  minSize: proTrackLevelWelcomeEmailInput,
  wrapperClassName: 'protrack-level-form__email-image-input',
  cropper: {
    outputWidth: proTrackLevelWelcomeEmailInput.width,
    outputHeight: proTrackLevelWelcomeEmailInput.height,
    renderWidth: proTrackLevelWelcomeEmailInput.width * 0.5,
    renderHeight: proTrackLevelWelcomeEmailInput.height * 0.5,
    scale: {
      min: 50,
      max: 200,
    },
  },
}

export const proTrackLevelFinishEmailInput = {
  width: width750,
  height: height448,
}

export const proTrackLevelFinishEmailInputProps = {
  entityName: 'image',
  title: 'Finish Email Image',
  minSize: proTrackLevelFinishEmailInput,
  wrapperClassName: 'protrack-level-form__email-image-input',
  cropper: {
    outputWidth: proTrackLevelFinishEmailInput.width,
    outputHeight: proTrackLevelFinishEmailInput.height,
    renderWidth: proTrackLevelFinishEmailInput.width * 0.5,
    renderHeight: proTrackLevelFinishEmailInput.height * 0.5,
    scale: {
      min: 50,
      max: 200,
    },
  },
}

export const activityVideoInputProps = {
  entityName: 'video',
  minSize: {
    width: 200,
    height: 120,
  },
  wrapperClassName: 'activity-video',
  cropper: {
    outputWidth: width750,
    outputHeight: height448,
    renderWidth: 250,
    renderHeight: 250,
    scale: {
      min: 50,
      max: 200,
    },
  },
}

export const reviewsMessaging = {
  width: 500,
  height: 500,
}

export const reviewsMessagingProps = {
  entityName: 'image',
  title: i18next.t('Reviewer Invitation image'),
  minSize: reviewsMessaging,
  wrapperClassName: 'activity-image',
  cropper: {
    outputWidth: reviewsMessaging.width,
    outputHeight: reviewsMessaging.height,
    renderWidth: reviewsMessaging.width * 0.5,
    renderHeight: reviewsMessaging.height * 0.5,
    scale: {
      min: 50,
      max: 200,
    },
  },
}
